import { c as _c } from "react/compiler-runtime";
import type { ElementType } from 'react';
import { Link, type LinkProps } from '@/components/Link';
import { appendCrossBrandParams } from '@/lib/appendCrossBrandParams';
import type { CmsFleetCategory } from '@/services/cms-sdk/';
export interface FleetCategoryLinkProps<T> extends Omit<LinkProps, 'href'> {
  noUrlComponent?: T;
  fleetCategory: CmsFleetCategory;
}
export function FleetCategoryLink(t0) {
  const $ = _c(25);
  let children;
  let className;
  let fleetCategory;
  let inTarget;
  let noUrlComponent;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      className,
      noUrlComponent,
      fleetCategory,
      target: inTarget,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = fleetCategory;
    $[4] = inTarget;
    $[5] = noUrlComponent;
    $[6] = props;
  } else {
    children = $[1];
    className = $[2];
    fleetCategory = $[3];
    inTarget = $[4];
    noUrlComponent = $[5];
    props = $[6];
  }
  let t1;
  let t2;
  let vehicleUrl;
  if ($[7] !== children || $[8] !== className || $[9] !== fleetCategory || $[10] !== inTarget || $[11] !== noUrlComponent) {
    t2 = Symbol.for("react.early_return_sentinel");
    bb0: {
      vehicleUrl = resolveFleetCategoryLink(fleetCategory);
      if (!vehicleUrl) {
        const Component = noUrlComponent || "p";
        let t3;
        if ($[15] !== Component || $[16] !== children || $[17] !== className) {
          t3 = className ? <Component className={className}>{children}</Component> : children;
          $[15] = Component;
          $[16] = children;
          $[17] = className;
          $[18] = t3;
        } else {
          t3 = $[18];
        }
        t2 = t3;
        break bb0;
      }
      t1 = vehicleUrl.includes("starrv.com") ? "_blank" : inTarget;
    }
    $[7] = children;
    $[8] = className;
    $[9] = fleetCategory;
    $[10] = inTarget;
    $[11] = noUrlComponent;
    $[12] = t1;
    $[13] = t2;
    $[14] = vehicleUrl;
  } else {
    t1 = $[12];
    t2 = $[13];
    vehicleUrl = $[14];
  }
  if (t2 !== Symbol.for("react.early_return_sentinel")) {
    return t2;
  }
  const target = t1;
  let t3;
  if ($[19] !== children || $[20] !== className || $[21] !== props || $[22] !== target || $[23] !== vehicleUrl) {
    t3 = <Link className={className} href={vehicleUrl} target={target} {...props}>{children}</Link>;
    $[19] = children;
    $[20] = className;
    $[21] = props;
    $[22] = target;
    $[23] = vehicleUrl;
    $[24] = t3;
  } else {
    t3 = $[24];
  }
  return t3;
}
function resolveFleetCategoryLink(fleetCategory: CmsFleetCategory) {
  const link = fleetCategory.pages?.[0].url;
  if (!link) {
    return null;
  }
  if (link.startsWith('http') && link.includes('starrv')) {
    return appendCrossBrandParams(new URL(link), fleetCategory.code).href;
  }
  return link;
}